// extracted by mini-css-extract-plugin
export default {"buttonContainer":"home_buttonContainer__IfMMv","button":"home_button__Voa1p"};